import React, { useEffect, useState } from 'react';
import MaterialTable from 'material-table';
import moment from 'moment';
import { Modal } from 'react-bootstrap';
import DraggableModal from '../UI/DraggableModal';
import useAPI from '../../hooks/useAPI';
import { localization, modifyDefaultOptions } from '../../helpers/table';

const historyChangesMap = {
    num: 'Номер',
    name: 'Название',
    endDate: 'Дата окончания',
    isHidden: 'Скрытый проект',
    isArchived: 'В архиве',
    usersDelete: 'Удалены пользователи',
    usersAdd: 'Добавлены пользователи',
};

function getUserChanges(prevUsers, users) {
    const newUsers = [];
    const deletedUsers = [];
    const visited = new Map();
    prevUsers.forEach((user) => {
        const userRoles = visited.get(user.userId);
        if (userRoles) {
            userRoles.push(user.role);
        } else {
            visited.set(user.userId, [user.role]);
        }
        if (!users.find((u) => u.userId === user.userId && u.role === user.role)) {
            deletedUsers.push(user);
        }
    });
    users.forEach((user) => {
        const visitedUser = visited.get(user.userId);
        if (!visitedUser || !visitedUser.includes(user.role)) {
            newUsers.push(user);
        }
    });
    return { newUsers, deletedUsers };
}

function getHistoryChangesDescription(changes) {
    const { prevVal, val } = changes;
    if (!prevVal) {
        return ['Проект создан'];
    }
    const changesDescription = [];
    Object.keys(val).forEach((key) => {
        if (prevVal[key] !== val[key]) {
            switch (key) {
                case 'endDate':
                    changesDescription.push(<span>
                      {historyChangesMap[key]}: <del>{prevVal[key] ? moment(prevVal[key]).format('DD.MM.YYYY') : 'Не указано'}</del> - {val[key] ? moment(val[key]).format('DD.MM.YYYY') : 'Не указано'}
                    </span>);
                    break;
                case 'isHidden':
                case 'isArchived':
                    changesDescription.push(<span>
                      {historyChangesMap[key]}: <del>{prevVal[key] ? 'Да' : 'Нет'}</del> - {val[key] ? 'Да' : 'Нет'}
                    </span>);
                    break;
                case 'users':
                    const { newUsers, deletedUsers } = getUserChanges(prevVal[key], val[key]);
                    if (newUsers.length > 0) {
                        changesDescription.push(`${historyChangesMap.usersAdd}: ${newUsers.map((u) => `${u.displayName} (${u.role})`).join(', ')}`);
                    }
                    if (deletedUsers.length > 0) {
                        changesDescription.push(`${historyChangesMap.usersDelete}: ${deletedUsers.map((u) => `${u.displayName} (${u.role})`).join(', ')}`);
                    }
                    break;
                default:
                    changesDescription.push(<span>
                      {historyChangesMap[key]}: <del>{prevVal[key] ?? 'Не указано'}</del> - {val[key] ?? 'Не указано'}
                    </span>);
            }
        }
    });
    return changesDescription;
}

export default function SPHistory({
 show, onHide, id, num,
}) {
    const [history, setHistory] = useState([]);
    const api = useAPI();

    useEffect(() => {
      const getHistory = async () => {
        const response = await api.get(`/mng/strategies/${id}/hists`);
        setHistory(response);
      };
      if (id) {
        getHistory();
      }
    }, [id]);

    return (
      <DraggableModal show={show} onHide={onHide} headerNode={`История изменений ${num}`} size="lg">
        <Modal.Body>
          <MaterialTable
            columns={[
                    {
                        title: 'Дата, время',
                        field: 'createdOn',
                        render: (rowData) => moment(rowData).format('DD.MM.YYYY'),
                    },
                    {
                        title: 'Пользователь',
                        field: 'userName',
                        render: (rowData) => rowData.user?.displayName,
                    },
                    {
                        title: 'Изменения',
                        field: 'changes',
                        cellStyle: { minWidth: 320 },
                        render: (rowData) => (
                          <ul style={{ listStyle: 'none' }}>
                            {getHistoryChangesDescription(rowData.changes).map((descripton) => (
                              <li>
                                {descripton}
                              </li>
                            ))}
                          </ul>
                        ),
                    },
                ]}
            data={history}
            options={modifyDefaultOptions({
                toolbar: false,
                sorting: false,
                filtering: false,
            })}
            localization={localization}
          />
        </Modal.Body>
      </DraggableModal>
    );
}
